module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.8369/images/rever/logo-r-red@2x.png"